define('glu/$document',['require','./$'],function(require) {
    'use strict';

    var $ = require('./$');

    return $(document);
});

